/**
 * Zentrale AT-SEO-Defaults. Spiegelt window.__BF_AT_SEO__ aus index.html —
 * beide MÜSSEN übereinstimmen, damit der erste React-Render byte-identisch
 * zum Roh-HTML ist. Wird nur konsumiert, wenn useStorefront().storefront === 'at'.
 *
 * CH bleibt unberührt: kein Import in CH-Renderpfaden ohne Ternary.
 */
export const AT_SEO_DEFAULTS = {
  // Passed as the `title` prop to <SEOHead>; SEOHead appends " | BigFollow"
  // (same suffix mechanism as CH). Final rendered title:
  //   "Follower kaufen – Instagram & TikTok Österreich | BigFollow"
  title: 'Follower kaufen – Instagram & TikTok Österreich',
  description:
    'Follower, Likes & Views für Instagram und TikTok kaufen. Bezahlung mit PayPal, Klarna, EPS oder Kreditkarte. Schnelle Lieferung in Österreich.',
  heroTitle: 'Follower kaufen – Instagram & TikTok',
  heroSubtitle: 'Instagram & TikTok schnell steigern',
  heroText:
    'Hochwertige, echte Follower sowie Likes, Views und Kommentare – in Minuten geliefert, bezahlt mit PayPal, Klarna, EPS oder Kreditkarte – einfach und zuverlässig für Österreich.',
} as const;